const operation = {
  // 获取反馈意见类型
  opinionConfig: `/jyhApi/user/opinionConfig`,
  // 上传反馈截图
  imageUpload: `/uploadsApi/cdnapp/universalUpload.php`,
  // 提交反馈意见
  opinion: `/jyhApi/user/opinion`,
  // 获取首页游戏列表
  recentlyPlayAndAllGame: `/jyhApi/game/recentlyPlayAndAllGame`,
  // 根據游戲類型獲取首頁游戲列表 - 賈琳
  recentlyPlayAndAllGameV2: `/jyhApi/game/recentlyPlayAndAllGameV2`,
  // 获取游戏列表
  pclist: `/jyhApi/game/pclist`,
  // 最新上线
  newgamelist: `/jyhApi/game/newgamelist`,
  // 最近成交
  latelyorder: `/jyhApi/order/latelyorder`,
  // 帮助中心本文获取
  helpCenter: `https://charge-api.996box.com/help.txt`,
  // 指定我列表
  target: `/jyhApi/commodity/target`,
  // 删除指定
  cancelTarget: `/jyhApi/commodity/cancelTarget`,
  // 我的交易信息
  getUserTrade: `/jyhApi/user/trade`,
  // 商品详情
  commodityDetail: `/jyhApi/commodity/detail`,
  // 社区商品详情（帖子分享商品卡片）
  shareCommodityDetail: `/jyhApi/shareCommodity/shareCommodityDetail`,
  // 商品收藏
  collect: `/jyhApi/commodity/collect`,
  // 取消收藏
  cancelCollect: `/jyhApi/commodity/cancelCollect`,
  // 砍价配置
  bargainConfig: `/jyhApi/commodity/bargainConfig`,
  // 砍价接口
  doBargain: `/jyhApi/commodity/doBargain`,
  // 取消砍价接口
  cancelBargain: `/jyhApi/commodity/cancelBargain`,
  // 我的还价
  myBargain: `/jyhApi/commodity/myBargain`,
  // 买家还价
  buyUserBargain: `/jyhApi/commodity/buyUserBargain`,
  // 卖家同意砍价
  agreeBargain: `/jyhApi/commodity/agreeBargain`,
  // 卖家拒绝砍价
  refuseBargain: `/jyhApi/commodity/refuseBargain`,
  // 给用户的手机号发送验证码
  sendSms: `/jyhApi/sms/user/send`,
  // 校验验证码
  checkSmsAuth: `/jyhApi/sms/check`,
  // 检验短信验证码并签发token
  checkSms: `/jyhApi/sms/checkPaySms`,
  // 检验短信验证码并签发token
  checkPayCode: `/jyhApi/sms/checkPayCode`,
  // 上架商品V2
  onshelfV2: `/jyhApi/commodity/onshelfV2`,
  // 下架V2
  downshelfV2: `/jyhApi/commodity/downshelfV2`,
  // 取回V2
  takeBackV2: `/jyhApi/commodity/takeBackV2`,
  // 修改价格V2
  modifyPriceV2: `/jyhApi/commodity/modify/priceV2`,
  // 买家还价(新)
  buyUserBargainNew: `/jyhApi/commodity/buyUserBargainNew`,
  // 用户是否下单
  userCreateOrderDetail: '/jyhApi/order/userCreateOrderDetail',
  // 交易行文案配置
  copyWrite: '/jyhApi/commodity/copyWrite',
  // 购物车/收藏降价气泡、引导弹窗与通知开关
  priceDropStatus: '/jyhApi/commodity/priceDropStatus',
  // 降价提醒开关设置
  notifySetting: '/jyhApi/commodity/notifySetting',
  // 交易行商品详情
  chargeCommodityDetail: '/chargeApi/commodity/detail'
};

export default operation;
